// extracted by mini-css-extract-plugin
export default {"form_container":"styles_form_container__7mzKW","input":"styles_input__whcgR","submit_button":"styles_submit_button__iXEsx"};